import { render, staticRenderFns } from "./itemJugadorTarjeta.vue?vue&type=template&id=7398cc79&"
import script from "./itemJugadorTarjeta.vue?vue&type=script&lang=js&"
export * from "./itemJugadorTarjeta.vue?vue&type=script&lang=js&"
import style0 from "./itemJugadorTarjeta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports